import React from "react";

import {
  AllTermcondition,
  AllTermconditionContent,
} from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

// const PrivacyPolicy = () => {
//   const dispatch = useDispatch();

//   const all_terms_condition = useSelector(
//     (state) => state?.common?.all_terms_condition,
//   );

//   useEffect(() => {
//     dispatch(AllTermcondition());
//     // dispatch(AllPrivacyPolicy());
//   }, [dispatch]);

//   return (
//     <div className="privacy-policy terms-condition-contain">
//       <h2 className="privacy-title">Terms & Conditions</h2>

//       <p className="privacy-subtitle">
//         Welcome to Spirulina. By accessing our website, mobile application, or
//         purchasing our products, you agree to comply with and be bound by the
//         following Terms & Conditions. Please read them carefully before using
//         our services.
//       </p>

//       {/* Section 1 */}
//       <section id="1">
//         <h5 className="section-heading">1. Acceptance of Terms</h5>
//         <p className="sub-heading">
//           By using our website, app, or services, you confirm that you have
//           read, understood, and agreed to these Terms & Conditions. If you do
//           not agree, please do not use our services.
//         </p>
//       </section>

//       {/* Section 2 */}
//       <section id="2">
//         <h5 className="section-heading">2. Eligibility</h5>
//         <ul class="list">
//           <li>
//             Users must be 18 years or older to register or place an order.
//           </li>
//           <li>
//             You agree to provide accurate and complete information during
//             registration and ordering.
//           </li>
//         </ul>
//       </section>

//       {/* Section 3 */}
//       <section id="3">
//         <h5 className="section-heading">
//           3. Account Registration & Activation
//         </h5>
//         <ul className="list">
//           <li>
//             Account activation requires the purchase of at least one (1)
//             product.{" "}
//           </li>
//           <li>
//             Each user is responsible for maintaining the confidentiality of
//             their account credentials.{" "}
//           </li>
//           <li>
//             Any activity performed through your account will be considered your
//             responsibility.
//           </li>
//         </ul>
//       </section>

//       {/* Section 4 */}
//       <section id="4">
//         <h5 className="section-heading">4. Products & Usage</h5>
//         <ul className="list">
//           <li>
//             Our products are 100% natural supplements intended for general
//             wellness.
//           </li>
//           <li>
//             Products are not intended to diagnose, treat, cure, or prevent any
//             disease.
//           </li>
//           <li>
//             Always consult a healthcare professional before use if you have any
//             medical condition.
//           </li>
//         </ul>
//       </section>

//       {/* Section 5 */}
//       <section id="5">
//         <h5 className="section-heading">5. Orders, Pricing & Payments</h5>
//         <ul className="list">
//           <li>
//             All prices are listed in INR and are subject to change without prior
//             notice.
//           </li>
//           <li>
//             Orders will be processed only after successful payment confirmation.
//           </li>
//           <li>
//             We reserve the right to cancel or refuse any order at our
//             discretion.
//           </li>
//         </ul>
//       </section>

//       {/* Section 6 */}
//       <section id="6">
//         <h5 className="section-heading">6. Shipping & Delivery</h5>

//         <ul className="list">
//           <li>
//             Delivery timelines may vary based on location and availability.
//           </li>
//           <li>
//             We are not responsible for delays caused by courier partners,
//             natural events, or unforeseen circumstances.
//           </li>
//         </ul>
//       </section>

//       {/* Section 7 */}
//       <section id="7">
//         <h5 className="section-heading">7. Referral & Reward Program</h5>
//         <ul className="list">
//           <li>
//             Users may earn rewards by referring others as per the company’s
//             referral policy.
//           </li>
//           <li>
//             Referral income is subject to verification, eligibility, and
//             compliance rules.
//           </li>
//           <li>
//             Any misuse, false referrals, or unethical practices may result in
//             account suspension or termination.
//           </li>
//         </ul>
//       </section>

//       {/* Section 8 */}
//       <section id="8">
//         <h5 className="section-heading">8. Returns, Refunds & Cancellations</h5>
//         <ul class="list">
//           <li>
//             Return and refund requests will be handled as per our Refund Policy.
//           </li>
//           <li>Products once opened or used are generally non-returnable.</li>
//         </ul>
//       </section>

//       {/* Section 9 */}
//       <section id="9">
//         <h5 className="section-heading">9. Prohibited Activities</h5>
//         <p className="sub-heading">Users must not:</p>
//         <ul class="list">
//           <li>Provide false or misleading information.</li>
//           <li>Engage in fraudulent, abusive, or illegal activities.</li>
//           <li>Misuse referral systems or payment mechanisms.</li>
//           <li>Attempt unauthorized access to our systems.</li>
//         </ul>
//       </section>

//       <section id="10">
//         <h5 className="section-heading">10. Limitation of Liability</h5>
//         <p className="sub-heading">
//           Spirulina shall not be liable for any indirect, incidental, or
//           consequential damages arising from the use of our products or
//           services.
//         </p>
//       </section>

//       <section id="11">
//         <h5 className="section-heading">11. Intellectual Property</h5>
//         <p className="sub-heading">
//           All content, logos, images, and materials on this platform are the
//           property of Spirulina and may not be copied or used without prior
//           written permission.
//         </p>
//       </section>

//       <section id="12">
//         <h5 className="section-heading">12. Termination of Services</h5>
//         <p className="sub-heading">
//           We reserve the right to suspend or terminate any account that violates
//           these Terms & Conditions without prior notice.
//         </p>
//       </section>

//       <section id="13">
//         <h5 className="section-heading">13. Changes to Terms</h5>
//         <p className="sub-heading">
//           We may update these Terms & Conditions at any time. Continued use of
//           our services constitutes acceptance of the revised terms.
//         </p>
//       </section>

//       <section id="14">
//         <h5 className="section-heading">14. Governing Law</h5>
//         <p className="sub-heading">
//           These Terms & Conditions shall be governed by and interpreted in
//           accordance with the laws of India.
//         </p>
//       </section>
//     </div>
//   );
// };

const PrivacyPolicy = ({ activeTab }) => {
  const dispatch = useDispatch();

  const all_terms_condition = useSelector(
    (state) => state?.common?.all_terms_condition,
  );

  useEffect(() => {
    dispatch(AllTermcondition());
  }, [dispatch]);

  return (
    <div className="privacy-policy terms-condition-contain">
      <h2 className="privacy-title">Terms & Conditions</h2>

      {/* {all_terms_condition && all_terms_condition.length > 0 ? (
        all_terms_condition.map((item) => (
          <section id={item?.id} key={item?.id}>
            <h5 className="section-heading">{item?.title}</h5>

            {item?.description && (
              <p
                className="sub-heading"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              />
            )}

            {item?.points && item?.points?.length > 0 && (
              <ul className="list">
                {item?.points?.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            )}
          </section>
        ))
      ) : (
        <div className="no-data">Terms & Conditions is found</div>
      )} */}

      {all_terms_condition && all_terms_condition.length > 0 ? (
        all_terms_condition.map((item) => (
          <section id={item?.content_id} key={item?.id}>
            <h5 className="section-heading">
              {item?.termsconditioncontent?.name}
            </h5>

            {item?.description && (
              <div
                className="sub-heading"
                dangerouslySetInnerHTML={{
                  __html: item?.description || "",
                }}
              />
            )}
          </section>
        ))
      ) : (
        <p className="text-center mt-4">Terms & Conditions is not available</p>
      )}
    </div>
  );
};

export default PrivacyPolicy;
